module.exports = __webpack_public_path__ + "static/media/ill_infektioner.a61c232a.svg";